import React from 'react'
import { connect } from 'react-redux'
import Welcome from '../../components/main/Welcome'
import { bindActionCreators } from 'redux'
import { getCurrentUser, updateCustomerMessage, updateCustomerNotes } from '../../actions/userActions'
import { closePopup } from '../../actions/uiActions'
import Pepsi from '../../components/landingPages/Pepsi'
import Kellogg from '../../components/landingPages/Kellogg'
import Danone from '../../components/landingPages/Danone'
import Church from '../../components/landingPages/Church'
import SimpleMills from '../../components/landingPages/SimpleMills'
import Wise from '../../components/landingPages/Wise'
import KDRP from '../../components/landingPages/KDRP'
import JackLinks from '../../components/landingPages/JackLinks'
import Ghirardelli from '../../components/landingPages/Ghirardelli'
import Demo from '../../components/landingPages/Demo'
import CAInsights from '../../components/landingPages/CAInsights'
import CentralGarden from '../../components/landingPages/CentralGarden'
import Flora from '../../components/landingPages/Flora'
import Welcome1 from '../../components/landingPages/Welcome1'
import Welcome2 from '../../components/landingPages/Welcome2'
import Gallo from '../../components/landingPages/Gallo'

class WelcomeContainer extends React.Component {
    componentDidMount() {
        if (this.props.currentUser === null) {
            this.props.getCurrentUser(this.props.id)
        } else if (this.props.currentUser["id"] !== this.props.id) {
            // User logged in as someone else, reset permissions
            this.props.getCurrentUser(this.props.id)
        }

        this.props.closePopup()
    }

    render() {
        switch (this.props.customerName && this.props.customerName.toLowerCase()) {
            case "pepsi":
                return ( <
                    Pepsi {...this.props }
                    />
                )
            case "pepsi-kroger":
                return ( <
                    Pepsi {...this.props }
                    />
                )
            case "pepsi-southdiv":
                return ( <
                    Pepsi {...this.props }
                    />
                )
            case "kellogg":
            case "wkkellogg":
                return (<
                    Kellogg {...this.props }
                    />
                )

            case "danone":
                return ( <
                    Danone {...this.props }
                    />
                )

            case "church & dwight":
                return (<
                    Church {...this.props}
                />
                )

            case "simple mills":
                return (<
                    SimpleMills {...this.props}
                />
                )

            case "wise":
                return (<
                    Wise {...this.props}
                />
                )

            case "kdrp":
                return (<
                    KDRP {...this.props}
                />
                )
            case "jack links":
                return (<
                    JackLinks {...this.props}
                />
                )
            case "ghirardelli":
                return (<
                    Ghirardelli {...this.props}
                />
                )
            case "demo":
                return (<
                    Demo {...this.props}
                />
                )
            case "central garden & pet":
                return (<
                    CentralGarden {...this.props}
                />
                )
            case "welcome1":
                return (<
                    Welcome1 {...this.props}
                />
                )

            case "welcome2":
                return (<
                    Welcome2 {...this.props}
                />
                )

            case "ca insights":
                return (<
                    CAInsights {...this.props}
                />
                )
            case "flora":
                return (<
                    Flora {...this.props}
                />
                )

            case "gallo":
                return (<
                    Gallo {...this.props}
                />
                )
            default:
                return ( <
                    Welcome {...this.props }
                    />
                )
        }
    }
}

function mapStateToProps(state) {
    return {
        id: state.users.userID,
        role: state.users.role,
        customerID: state.users.customerID,
        message: state.users.message,
        notes: state.users.notes,
        customerName: state.users.customerName,
        firstName: state.users.firstName,
        lastName: state.users.lastName,
        currentUser: state.users.currentUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ getCurrentUser, updateCustomerMessage, updateCustomerNotes, closePopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeContainer)